/** Phase E-2: BookingTab — ko/en/vi/ru */

const bookingTab = {
  tabPending: ['대기', 'Pending', 'Chờ', 'Ожидание'],
  tabAllocated: ['확정', 'Confirmed', 'Đã xác nhận', 'Подтверждено'],
  tabCompleted: ['완료', 'Completed', 'Hoàn tất', 'Завершено'],
  tabCancelled: ['취소', 'Cancelled', 'Đã hủy', 'Отменено'],
  // 이 탭은 모든 업종(투어/숙소/뷰티·웰니스 등) 대시보드에서 공통으로 쓰이는 예약 필터라
  // "출발일별"이라고 하면 미용실/마사지 같은 예약제 업종에서 의미가 안 맞아서 "날짜별"로 통일함.
  // 실제 투어 출발일 관련 문구(여행자 명단의 departureDateLine 등)는 그대로 둠.
  tabByDeparture: ['날짜별', 'By date', 'Theo ngày', 'По дате'],
  timeoutExpired: ['만료', 'Expired', 'Hết hạn', 'Истекло'],
  acceptDeadline: ['수락 마감 {left}', 'Accept by {left}', 'Chấp nhận trước {left}', 'Принять до {left}'],
  acceptSuccess: ['수락했습니다.', 'Accepted.', 'Đã chấp nhận.', 'Принято.'],
  declineSuccess: ['거절했습니다.', 'Declined.', 'Đã từ chối.', 'Отклонено.'],
  completeSuccess: [
    '완료 처리했습니다. 고객에게 리뷰 유도 알림이 갔어요.',
    'Marked as completed. The customer got a review-prompt notification.',
    'Đã hoàn tất. Khách hàng đã nhận thông báo mời đánh giá.',
    'Отмечено как завершено. Клиент получил уведомление с просьбой оставить отзыв.',
  ],
  detailLoadFail: ['상세 로드 실패', 'Could not load details', 'Không tải được chi tiết', 'Не удалось загрузить'],
  packageFallback: ['패키지', 'Package', 'Gói', 'Пакет'],
  tourFallback: ['투어', 'Tour', 'Tour', 'Тур'],
  guestFallback: ['게스트', 'Guest', 'Khách', 'Гость'],
  comboComponentsLabel: ['포함 서비스', 'Included services', 'Dịch vụ bao gồm', 'Включённые услуги'],
  manifestTitle: ['[{title}] 여행자 명단', '[{title}] Traveler list', '[{title}] Danh sách du khách', '[{title}] Список путешественников'],
  departureDateLine: ['출발일: {date}', 'Departure: {date}', 'Ngày đi: {date}', 'Выезд: {date}'],
  manifestCopied: ['명단이 복사됐어요', 'List copied', 'Đã sao chép danh sách', 'Список скопирован'],
  departureManifestCopied: ['출발일 전체 명단이 복사됐어요', 'Departure-day list copied', 'Đã sao chép danh sách theo ngày đi', 'Список на дату выезда скопирован'],
  excelDownloaded: ['엑셀 파일을 다운로드했어요', 'Excel file downloaded', 'Đã tải file Excel', 'Файл Excel загружен'],
  premiumOnly: ['프리미엄 플랜에서 이용할 수 있어요', 'Available on Premium plan', 'Chỉ gói Premium', 'Доступно на Premium'],
  insuranceSaved: ['보험 상태가 저장됐어요', 'Insurance status saved', 'Đã lưu trạng thái bảo hiểm', 'Статус страховки сохранён'],
  saveFail: ['저장 실패', 'Could not save', 'Không lưu được', 'Не удалось сохранить'],
  noTravelerInfo: ['여행자 정보가 없어요', 'No traveler info', 'Chưa có thông tin du khách', 'Нет данных путешественника'],
  bookerNotFound: ['예약자 정보를 찾을 수 없어요', 'Booker not found', 'Không tìm thấy người đặt', 'Бронирующий не найден'],
  travelerInfoRequestTitle: ['출발 전 여행자 정보 입력', 'Traveler info before departure', 'Nhập thông tin trước khi đi', 'Данные путешественника до выезда'],
  travelerInfoRequestBody: [
    '원활한 여행 서비스를 위해 여행자 정보를 입력해주세요. 보험 가입 및 픽업 서비스에 필요한 정보예요.',
    'Please enter traveler details for insurance and pickup services.',
    'Nhập thông tin du khách cho bảo hiểm và đón sân bay.',
    'Укажите данные для страховки и трансфера.',
  ],
  requestSent: ['정보 입력 요청 알림을 보냈어요', 'Reminder sent', 'Đã gửi nhắc nhở', 'Напоминание отправлено'],
  notifySendFail: ['알림 발송 실패', 'Could not send notification', 'Không gửi được thông báo', 'Не удалось отправить'],
  noMissingBookings: ['미입력 예약이 없어요', 'No incomplete bookings', 'Không có đặt chỗ thiếu thông tin', 'Нет незаполненных броней'],
  bulkRequestSent: ['{n}명에게 입력 요청 알림을 보냈어요', 'Reminders sent to {n} guests', 'Đã gửi cho {n} khách', 'Напоминания отправлены {n} гостям'],
  bulkRequestFail: ['알림을 보낼 수 없어요', 'Could not send reminders', 'Không gửi được nhắc nhở', 'Не удалось отправить'],
  staffSavePending: [
    '저장됐어요. 카카오/잘로/WhatsApp은 n8n 연동 대기열에 등록됐어요.',
    'Saved. Kakao/Zalo/WhatsApp queued for n8n delivery.',
    'Đã lưu. Kakao/Zalo/WhatsApp chờ n8n.',
    'Сохранено. Kakao/Zalo/WhatsApp в очереди n8n.',
  ],
  staffSaveSuccess: ['담당자 배정이 저장됐어요', 'Staff assignment saved', 'Đã lưu phân công', 'Назначение сохранено'],
  ocrChargeSoon: ['충전은 준비 중이에요', 'Top-up coming soon', 'Nạp tiền sắp có', 'Пополнение скоро'],
  filterByProduct: ['특정 상품 예약만 보는 중', 'Showing bookings for one listing', 'Chỉ đặt chỗ của một sản phẩm', 'Брони одного товара'],
  missingBanner: ['{n}명이 여행자 정보를 아직 입력하지 않았어요', '{n} guests have not submitted traveler info', '{n} khách chưa nhập thông tin', '{n} гостей без данных'],
  requestAllBtn: ['입력 요청 알림 보내기', 'Send reminders', 'Gửi nhắc nhở', 'Отправить напоминания'],
  emptyTitle: ['아직 예약이 없어요', 'No bookings yet', 'Chưa có đặt chỗ', 'Пока нет броней'],
  emptySub: ['상품을 등록하면 예약을 받을 수 있어요', 'List a product to receive bookings', 'Đăng sản phẩm để nhận đặt chỗ', 'Добавьте товар для броней'],
  emptySubService: ['서비스를 등록하면 예약을 받을 수 있어요', 'List a service to receive bookings', 'Đăng dịch vụ để nhận đặt chỗ', 'Добавьте услугу для броней'],
  emptyCta: ['상품 등록하기', 'Add listing', 'Đăng sản phẩm', 'Добавить товар'],
  emptyCtaService: ['서비스 등록하기', 'Add service', 'Đăng dịch vụ', 'Добавить услугу'],
  metaGuests: ['{guest} · {count} · {date}', '{guest} · {count} · {date}', '{guest} · {count} · {date}', '{guest} · {count} · {date}'],
  participantsUnit: ['{n}명', '{n} guests', '{n} khách', '{n} гостей'],
  detailClose: ['상세 닫기', 'Hide details', 'Đóng chi tiết', 'Скрыть'],
  detailOpen: ['예약 상세', 'Booking details', 'Chi tiết đặt chỗ', 'Детали брони'],
  acceptBtn: ['수락하기', 'Accept', 'Chấp nhận', 'Принять'],
  declineBtn: ['거절하기', 'Decline', 'Từ chối', 'Отклонить'],
  completeBtn: ['이용완료 처리', 'Mark completed', 'Đánh dấu hoàn tất', 'Отметить завершённым'],
  bookerInfoTitle: ['예약자 정보', 'Booker info', 'Thông tin người đặt', 'Данные бронирующего'],
  travelerInfoMissing: ['아직 여행자 정보를 입력하지 않았어요', 'Traveler info not submitted yet', 'Chưa nhập thông tin du khách', 'Данные ещё не введены'],
  labelName: ['이름', 'Name', 'Tên', 'Имя'],
  labelBirthDate: ['생년월일', 'Date of birth', 'Ngày sinh', 'Дата рождения'],
  labelContact: ['연락처', 'Phone', 'Điện thoại', 'Телефон'],
  labelEmail: ['이메일', 'Email', 'Email', 'Email'],
  labelHotel: ['호텔', 'Hotel', 'Khách sạn', 'Отель'],
  labelPassport: ['여권', 'Passport', 'Hộ chiếu', 'Паспорт'],
  labelAllergy: ['알레르기', 'Allergies', 'Dị ứng', 'Аллергии'],
  labelSpecialRequests: ['특별 요청', 'Special requests', 'Yêu cầu đặc biệt', 'Особые пожелания'],
  companionLine: ['동반', 'Companion', 'Đi cùng', 'Спутник'],
  copyManifest: ['명단 복사', 'Copy list', 'Sao chép danh sách', 'Копировать список'],
  excelDownload: ['엑셀 다운로드', 'Download Excel', 'Tải Excel', 'Скачать Excel'],
  requestInfo: ['정보 입력 요청', 'Request info', 'Yêu cầu nhập', 'Запросить данные'],
  staffAssignTitle: ['담당자 배정', 'Staff assignment', 'Phân công nhân sự', 'Назначение персонала'],
  notifyTimingLabel: ['발송 시점', 'Send timing', 'Thời điểm gửi', 'Время отправки'],
  notifyImmediate: ['즉시 발송', 'Send now', 'Gửi ngay', 'Сразу'],
  notify1d: ['출발 1일 전', '1 day before', 'Trước 1 ngày', 'За 1 день'],
  notify2d: ['출발 2일 전', '2 days before', 'Trước 2 ngày', 'За 2 дня'],
  notify3d: ['출발 3일 전', '3 days before', 'Trước 3 ngày', 'За 3 дня'],
  notifyCustom: ['직접 입력', 'Custom', 'Tùy chỉnh', 'Своё'],
  resendOnUpdate: ['정보 수정 시 재발송', 'Resend when info changes', 'Gửi lại khi cập nhật', 'Повтор при изменении'],
  notifyHint: [
    '저장 시 설정된 시점에 각 담당자와 손님에게 일정표가 발송됩니다',
    'Itinerary will be sent to staff and guests at the scheduled time when you save.',
    'Lịch trình sẽ gửi cho nhân sự và khách theo thời điểm đã đặt khi lưu.',
    'Маршрут отправится персоналу и гостям в заданное время после сохранения.',
  ],
  save: ['저장하기', 'Save', 'Lưu', 'Сохранить'],
  ageSuffix: ['{age}세', 'Age {age}', '{age} tuổi', '{age} лет'],
  excelRole: ['구분', 'Role', 'Loại', 'Роль'],
  excelNameKr: ['한글명', 'Name (KR)', 'Tên (KR)', 'Имя (KR)'],
  excelNameEn: ['영문명', 'Name (EN)', 'Tên (EN)', 'Имя (EN)'],
  excelBirthDate: ['생년월일', 'Birth date', 'Ngày sinh', 'Дата рождения'],
  excelAge: ['나이', 'Age', 'Tuổi', 'Возраст'],
  excelGender: ['성별', 'Gender', 'Giới tính', 'Пол'],
  excelContact: ['연락처', 'Phone', 'Điện thoại', 'Телефон'],
  excelHotel: ['호텔', 'Hotel', 'Khách sạn', 'Отель'],
  excelPassportNo: ['여권번호', 'Passport no.', 'Số hộ chiếu', '№ паспорта'],
  excelPassportExpiry: ['만료일', 'Expiry', 'Hết hạn', 'Срок'],
  excelSsnMasked: ['주민번호(마스킹)', 'SSN (masked)', 'SSN (ẩn)', 'SSN (маск.)'],
  rolePrimary: ['대표', 'Primary', 'Chính', 'Основной'],
  roleCompanion: ['동반', 'Companion', 'Đi cùng', 'Спутник'],
};

function pick(map, langIndex) {
  const out = {};
  Object.entries(map).forEach(([k, arr]) => {
    out[k] = arr[langIndex];
  });
  return out;
}

function buildLang(langIndex) {
  return { dashboard: { bookingTab: pick(bookingTab, langIndex) } };
}

export const phaseE2Ko = buildLang(0);
export const phaseE2En = buildLang(1);
export const phaseE2Vi = buildLang(2);
export const phaseE2Ru = buildLang(3);

export const BOOKING_FILTER_TABS = [
  { key: 'pending', labelKey: 'dashboard.bookingTab.tabPending' },
  { key: 'allocated', labelKey: 'dashboard.bookingTab.tabAllocated' },
  { key: 'completed', labelKey: 'dashboard.bookingTab.tabCompleted' },
  { key: 'cancelled', labelKey: 'dashboard.bookingTab.tabCancelled' },
  { key: 'by_departure', labelKey: 'dashboard.bookingTab.tabByDeparture' },
];

export const NOTIFY_MODE_OPTIONS = [
  { mode: 'immediate', labelKey: 'dashboard.bookingTab.notifyImmediate' },
  { mode: '1d', labelKey: 'dashboard.bookingTab.notify1d' },
  { mode: '2d', labelKey: 'dashboard.bookingTab.notify2d' },
  { mode: '3d', labelKey: 'dashboard.bookingTab.notify3d' },
  { mode: 'custom', labelKey: 'dashboard.bookingTab.notifyCustom' },
];

export function excelColumnLabels(t) {
  return {
    role: t('dashboard.bookingTab.excelRole'),
    nameKr: t('dashboard.bookingTab.excelNameKr'),
    nameEn: t('dashboard.bookingTab.excelNameEn'),
    birthDate: t('dashboard.bookingTab.excelBirthDate'),
    age: t('dashboard.bookingTab.excelAge'),
    gender: t('dashboard.bookingTab.excelGender'),
    contact: t('dashboard.bookingTab.excelContact'),
    hotel: t('dashboard.bookingTab.excelHotel'),
    passportNo: t('dashboard.bookingTab.excelPassportNo'),
    passportExpiry: t('dashboard.bookingTab.excelPassportExpiry'),
    ssnMasked: t('dashboard.bookingTab.excelSsnMasked'),
  };
}

export function localeForLanguage(language) {
  if (language === 'ko') return 'ko-KR';
  if (language === 'vi') return 'vi-VN';
  if (language === 'ru') return 'ru-RU';
  return 'en-US';
}
